import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { Container } from 'yoso';
import { useLand } from '~/components/Land';
import styles from '~/components/Land/Detail/LandDetailPage.module.scss';
import { LandJumbotron } from '~/components/Land/Jumbotron/LandJumbotron';
import { LandRequirement } from '~/components/Land/Requirement/LandRequirement';
import { LandZoneCardList } from '~/components/Land/Zone/Card/List/LandZoneCardList';
import { ZoneParticipationGuide } from '~/components/Land/Zone/Guide/ZoneParticipationGuide';
import { Page } from '~/components/Page';
import { Section } from '~/components/Page/Section/Section';
import landStyles from '~/components/Style/Land.module.scss';

export const LandDetailPage = () => {
  const { landId: strLandId = '1' } = useParams<{
    week: string;
    landId: string;
  }>();
  const id = Number(strLandId);

  const {
    data: { landType },
    isInitialLoading,
  } = useLand(id);

  return (
    <Page
      className={classNames(styles.root, {
        [landStyles[landType]]: !isInitialLoading,
      })}>
      <Container margin="auto">
        <Section className={styles.pageSection}>
          <Section className={styles.heroSection}>
            <LandJumbotron id={id} />
          </Section>
          <Section>
            <LandZoneCardList id={id} />
          </Section>
          <Section>
            <LandRequirement />
          </Section>
          <Section>
            <ZoneParticipationGuide />
          </Section>
        </Section>
      </Container>
    </Page>
  );
};
